<template>
    <div v-if="hasItemTagId === true">
        <a class="tm-tag"
           :href="'/catalog/' + ShopTag.path">{{ ShopTag.name }}</a>
    </div>
</template>

<script>
    export default {
        props: {
            ShopTag: {
                type: Object,
                required: true
            },
            ShopItems: {
                type: Array,
                required: true
            },
            ShopItemTags: {
                type: Object,
                required: true
            }
        },
        data(){
            return {
                ArrayShopItemTags: []
            }
        },
        mounted() {
            this.ShopItems.forEach(function (Item) {
                if(this.ShopItemTags[Item.ShopItem.id]) {
                    this.ArrayShopItemTags = this.ArrayShopItemTags.concat(this.ShopItemTags[Item.ShopItem.id]);
                }
            }, this);
        },
        computed: {
            hasItemTagId() {
                return this.ArrayShopItemTags.some((itemtag) => {
                    return itemtag.ShopItemTag.id == this.ShopTag.id
                });
            }
        },
        methods: {

        }
    }
</script>



// WEBPACK FOOTER //
// ShopTag.vue?b02d9248